<template>
  <div class="index">
    <van-search
      background="#fff"
      placeholder="大家正在搜：市场震动怎么办"
      @click="goSearch('')"
    />
    <div class="searchsBox">
      <div v-for="(i, ind) in historyList" :key="ind" @click="goSearch(i)">
        <span v-if="i != ''"> {{ i }}</span>
      </div>
    </div>
   
    <!-- 最近热门 -->
    <div class="hot_copy" v-if="hotList.length > 0">
      <div class="hot_copy_title">最近热门</div>
      <!-- 前三名 -->
      <div class="hot_copy_no1" @click="goDetails(hotList[0].id)">
        <div class="overflowh">{{ hotList[0].title }}</div>
      </div>
      <div class="hot_copy_no2" @click="goDetails(hotList[1].id)">
        <div class="overflowh">{{ hotList[1].title }}</div>
      </div>
      <div class="hot_copy_no3" @click="goDetails(hotList[2].id)">
        <div class="overflowh">{{ hotList[2].title }}</div>
      </div>
    </div>
    <!-- 广告轮播 -->
    <div class="swipeBox">
      <!--  -->
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#894FDA">
        <van-swipe-item v-for="(i, ind) in banner" :key="ind">
          <a :href="i.url"><img :src="i.banner" /></a>
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- 话术库热门回答 -->
    <div class="question">
      <h4 class="newBlock">话术库热门回答</h4>
      <div
        class="questionList"
        v-for="(i, ind) in list"
        :key="ind"
        v-show="ind < 2"
        @click="goDetails(i.id)"
      >
        <div class="bgTit">
          <img src="../assets/image/questionIcon.png" class="questionIcon" />
          <h4>
            {{ i.title }}
          </h4>
        </div>

        <div
          class="content1"
          id="content1"
          v-if="i.type == 2"
          v-html="i.answer"
        ></div>
        <div class="content" v-if="i.type == 1">
          {{ i.answer }}
        </div>
      </div>
    </div>
    <!-- 知识库热门回答 -->
    <div class="question" style="margin: 25px 0">
      <h4 class="newBlock">知识库热门回答</h4>
      <div
        class="questionList"
        v-for="(i, ind) in hotList4"
        :key="ind"
        v-show="ind < 2"
        @click="goDetails(i.id)"
      >
        <div class="bgTit">
          <img src="../assets/image/questionIcon1.png" class="questionIcon" />
          <h4>
            {{ i.title }}
          </h4>
        </div>

        <div
          class="content1"
          id="content1"
          v-if="i.type == 2"
          v-html="i.answer"
        ></div>
        <div class="content" v-if="i.type == 1">
          {{ i.answer }}
        </div>
      </div>
    </div>
    <!-- 汇总 -->
    <div class="hskhz" @click="goIndex1">
      <img
        src="../assets/image/d.png"
        style="width: 15px; margin-right: 10px"
      />
      <div>话术库汇总</div>
      <span class="hskhz_more">查看更多》</span>
    </div>
    <div class="hskhz" @click="goIndex2">
      <img
        src="../assets/image/e.png"
        style="width: 15px; margin-right: 10px"
      />
      <div style="color: #6d81ff">知识库汇总</div>
      <span class="hskhz_more">查看更多》</span>
    </div>
    <!-- <div class="hsk">
      <div class="hskTit">
        <h4>话术库汇总</h4>
        <div class="moreBox" @click="goIndex1">
          查看更多 <img src="../assets/image/more.png" class="moreIcon" />
        </div>
      </div>
      <div class="hskContent">
        <div  v-for="(i, ind) in hotList3" v-show="ind < 3" :key="i.id" class="hskContentItem"  @click="goDetails(i.id)">{{i.title}}</div>
      </div>
    </div> -->
    <div class="bottomText">
      本话术库由汇添富基金联合启势广告开发<br />
      版权所有。基金有风险，投资须谨慎
    </div>
    <tab></tab>
  </div>
</template>

<script>
import { home, answerDetails, catalogList } from "@/api/index";
import tab from "@/components/tab";
export default {
  name: "index",
  components: { tab },
  data() {
    return {
      showMore: false,
      msg: "",
      banner: [],
      list: [],
      hotList: [],
      hotList1: [],
      hotList3: [],
      hotList4: [],
      historyList: [],
      questionObj: {
        title: "",
        answer: "",
        type: null,
      },
    };
  },
  created() {
    this.getData();
    // this.getCatalogList();
    if (JSON.parse(localStorage.getItem("historyList"))) {
      let historyList = JSON.parse(localStorage.getItem("historyList"));
      historyList = [...new Set(historyList)];
      this.historyList = historyList.filter((s) => {
        return s && s.trim(); // 注：IE9(不包含IE9)以下的版本没有trim()方法
      });
      this.historyList = this.historyList.slice(0, 5);
      console.log();
    }
  },
  methods: {
    goIndex1() {
      this.$router.push({
        path: "/index1",
      });
    },
    goIndex2() {
      this.$router.push({
        path: "/index2",
      });
    },
    getData() {
      home()
        .then((res) => {
          if (res.code == 0) {
            console.log(res);
            this.banner = res.data.banner;
            // this.hotList3 = res.data.top_news;
            this.list = res.data.top_news;
            this.hotList4 = res.data.top_knows;
            this.hotList = res.data.top_hots;
            // this.fun1(res.data.top_news);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getCatalogList() {
      catalogList()
        .then((res) => {
          if (res.code == 0) {
            console.log(res);
            let list = res.data.list[0];
            this.hotList4 = list.list;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    fun1(arr) {
      for (var i = 0; i < arr.length / 2; i++) {
        this.hotList[i] = arr[i * 2];
        this.hotList1[i] = arr[i * 2 + 1];
      }
      if (typeof this.hotList[this.hotList.length - 1] == "undefined") {
        this.hotList.pop();
      }
      if (typeof this.hotList1[this.hotList1.length - 1] == "undefined") {
        this.hotList1.pop();
      }
      let id = this.hotList[0].id;
      this.getDetails(id);
    },
    getDetails(id) {
      answerDetails({ id: id })
        .then((res) => {
          if (res.code == 0) {
            this.questionObj = res.data.top_news;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    goSearch(item) {
      this.$router.push({
        path: "/search",
        query: {
          msg: item,
        },
      });
    },
    goDetails(id) {
      this.$router.push({
        path: "/details",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>
<style lang="less">
img {
  max-width: 100%;
  height: auto;
}
</style>
<style lang="less" scoped>
.index {
  width: 92%;
  margin: 0 auto;
  padding-bottom: 7.5rem;
  position: relative;
  h5 {
    margin: 0.625rem 0;
  }
  .van-search {
    padding: 0.625rem 0;
  }
  .van-search__content {
    padding-left: 0;
    background-color: #fff;
  }
  .van-search .van-cell {
    line-height: 2rem;
    background: #f4f4f4;
    border-radius: 3.125rem;
    padding: 0 10px;
    box-sizing: border-box;
  }
  .searchsBox {
    display: flex;
    flex-wrap: wrap;

    span {
      display: inline-block;
      margin-right: 0.625rem;
      margin-bottom: 0.3125rem;
      padding: 0.5rem 0.75rem;
      border-radius: 1.25rem;
      background: #fff;
      border: 1px solid #ededed;
      color: #333;
      font-size: 0.875rem;
    }
  }
  .hot {
    .hotList {
      background: #fff;
      border-radius: 0.9375rem;
      height: auto;
      padding: 0.3125rem 0.9375rem;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      .left,
      .right {
        width: 49%;
        span {
          display: block;
          line-height: 2.1875rem;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .left {
        border-right: 0.0625rem solid #eee;
      }
      .right {
        padding-left: 0.625rem;
        .moreHot {
          color: #ff7e40;
        }
      }
    }
  }
  .swipeBox {
    max-height: 120px;
    margin: 30px 0 35px;
    img {
      width: 100%;
      height: 120px;
      border-radius: 1.25rem;
    }
  }
  .question {
    .questionList {
      background: #fff;
      border-radius: 0.9375rem;
      height: auto;
      overflow: hidden;
      // box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.12);
      // padding: 0.5125rem 0.7rem;
      border: 1px solid #f6f6f6;
      box-sizing: border-box;
      margin-bottom: 1.3rem;
      .bgTit {
        padding: 8px;
        display: flex;
        align-items: flex-start;
        // height: 30px;
        line-height: 1.5625rem;
        background: #f6f6f6;
        // background:red;
        h4 {
          margin: 0;
          font-size: 14px;
        }
        .questionIcon {
          display: inline-block;
          width: 1.125rem;
          height: 1.25rem;
          margin-right: 0.5rem;
          margin-top: 0.2875rem;
        }
      }
      .content1 {
        padding: 12px 11px 5px;
        height: 6.4rem;
        box-sizing: border-box;
        line-height: 1.5625rem;
        width: 100%;
      }
      .content {
        padding: 0.3125rem 0.625rem;
        height: 6.2rem;
        box-sizing: border-box;
        line-height: 1.5625rem;
        // font-size: 0.875rem;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        word-break: break-all;
      }
    }
  }
  .hsk {
    .hskTit {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .moreBox {
        font-size: 12px;
        color: #999999;
        .moreIcon {
          width: 10px;
        }
      }
    }
    .hskContent {
      box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.12);
      height: 8.2rem;
      background: #fff;
      border-radius: 0.9375rem;
      overflow: hidden;
      line-height: 38px;
      padding: 10px 15px;
      box-sizing: border-box;
      .hskContentItem {
        color: #333333;
        font-size: 14px;
        width: 100%;
        border-bottom: 1px solid #d8d8d8;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        &:nth-child(3) {
          border-bottom: 0;
        }
      }
    }
  }
  .bottomText {
    position: absolute;
    width: 100%;
    text-align: center;
    bottom: 3.8rem;
    font-size: 0.75rem;
    color: #999;
  }
}
.hot_copy {
  margin: 20px 0;
  .hot_copy_title {
    font-size: 16px;
    font-weight: 600;
    position: relative;
    margin-bottom: 15px;
    z-index: 2;
    &::after {
      content: "";
      position: absolute;
      width: 64px;
      height: 7px;
      border-radius: 4px;
      left: 0;
      bottom: 1px;
      z-index: -1;
      background-image: linear-gradient(#f4bf4a, #fae181);
    }
  }
  .hot_copy_no1 {
    color: #fff;
    height: 56px;
    line-height: 56px;
    font-size: 14px;
    font-weight: 700;
    width: 100%;
    background: url(../assets/image/a.png) no-repeat;
    background-size: 100% 100%;
    padding-left: 55px;
    box-sizing: border-box;
  }
  .hot_copy_no2 {
    color: #fff;
    height: 56px;
    line-height: 56px;
    font-size: 14px;
    font-weight: 700;
    margin: 15px 0;
    width: 100%;
    background: url(../assets/image/b.png) no-repeat;
    background-size: 100% 100%;
    padding-left: 55px;
    box-sizing: border-box;
  }
}
.overflowh {
  width: 97.5%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.newBlock {
  font-size: 16px;
  font-weight: 600;
  position: relative;
  margin-bottom: 15px;
  z-index: 2;
  &::after {
    content: "";
    position: absolute;
    width: 113px;
    height: 7px;
    border-radius: 4px;
    left: 0;
    bottom: 1px;
    z-index: -1;
    background-image: linear-gradient(#f4bf4a, #fae181);
  }
}
.hskhz {
  width: 100%;
  height: 45px;
  margin-bottom: 15px;
  border-radius: 10px;
  padding: 0 15px;
  box-sizing: border-box;
  font-size: 15px;
  font-weight: bold;
  background: #f6f6f6;
  color: #ff735e;
  display: flex;
  align-items: center;
  .hskhz_more {
    font-size: 12px;
    color: #999999;
    font-weight: 400;
    margin-left: 48%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue